import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://axjugomavcpjuegkhkya.supabase.co"
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4anVnb21hdmNwanVlZ2toa3lhIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODQyNTE0OTgsImV4cCI6MTk5OTgyNzQ5OH0.1n_67YT4Y_xnpsdka0HJTr_xZKeEQ3wFuSQOjv9-IOU"

export const supabaseClient = createClient(supabaseUrl, supabaseKey);
